// Links that open the phone, WhatsApp or an email for a client: a port of
// core/shared/utils/contact_links.dart.

/** `tel:` keeping only digits and a leading plus. */
export function phoneHref(phone: string): string | null {
  const cleaned = phone.replace(/[^0-9+]/g, '');
  return cleaned.replace(/\+/g, '') ? `tel:${cleaned}` : null;
}

/**
 * wa.me in the international form WhatsApp needs: a local Nigerian number
 * such as 0803 555 0101 becomes 2348035550101. Without a number, WhatsApp
 * asks who to send to.
 */
export function whatsappHref(phone: string, text = ''): string {
  let digits = phone.replace(/[^0-9]/g, '');
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.startsWith('0') && digits.length === 11) digits = `234${digits.slice(1)}`;
  const query = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${digits}${query}`;
}

/** A new email to [to] (may be empty), with spaces as %20 since mail apps show `+` as is. */
export function emailDraftHref(to: string, subject: string, body: string): string {
  return `mailto:${to.trim()}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

/** Copies text, falling back to a hidden text area where the clipboard API is blocked. */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const area = document.createElement('textarea');
    area.value = text;
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    area.remove();
    return ok;
  }
}
